import React from 'react';
import Modal from 'ds/components/modal';
import Icon from 'assets/svg/lamp.svg';
import styled from '@emotion/styled';
import { H3, Text } from 'ds/components/typography';
import { useLocale } from 'locale';
import { InvestorsFeedbackModalState } from 'store/state/app';

interface PostFeedbackModalProps {
  onModalClose: (data: InvestorsFeedbackModalState) => void;
}

const Root = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: theme.spacing(4),
  maxWidth: '290px',
  margin: '0 auto',
}));

const TextWrapper = styled.div(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

const Btn = styled(Text)(({ theme }) => ({
  color: theme.colors.brand.main,
  cursor: 'pointer',
  textAlign: 'center',
}));

export const PostFeedbackModal: React.FC<PostFeedbackModalProps> = props => {
  const { onModalClose } = props;
  const { t } = useLocale();

  return (
    <Modal desktopModalPositionCenter mobileModalPositionBottom isOpen onClose={() => onModalClose({ isPostFeedbackModalOpen: false, isModalOpen: false })}>
      <Root>
        <Icon />
        <TextWrapper>
          <H3 weight="bold">{t('investors.disclaimer.post.form.title.copy')}</H3>
          <Text>{t('investors.disclaimer.post.form.description.copy')}</Text>
        </TextWrapper>
        <Btn weight="bold" onClick={() => onModalClose({ isPostFeedbackModalOpen: false, isModalOpen: true })}>{t('investors.disclaimer.post.form.submit.copy')}</Btn>
      </Root>
    </Modal>
  );
};
